export default "__VITE_ASSET__CBTbZvVS__"